import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EventDto } from '@millionshow/api-client';
import { Fieldset, FormatInputDirective } from '@millionshow/client-libs';

@Component({
  selector: 'app-registration-info',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, Fieldset, FormatInputDirective],
  template: `
    <form [formGroup]="form()">
      <div class="flex flex-col gap-6">
        <div
          class="flex flex-col gap-3 border border-zinc-100 rounded-2xl p-5 bg-white">
          <h2 class="text-lg font-semibold text-zinc-800">행사 정보</h2>

          <app-fieldset label="행사 선택" required>
            <select
              formControlName="eventId"
              class="select cursor-pointer w-full">
              <option value="">선택해주세요</option>
              @for (event of events(); track event.id) {
              <option [value]="event.id">{{ event.title }}</option>
              }
            </select>
          </app-fieldset>
        </div>
        <div
          class="flex flex-col gap-6 border border-zinc-100 rounded-2xl p-5 bg-white">
          <h2 class="text-lg font-semibold text-zinc-800">신청자 정보</h2>

          <app-fieldset label="이름" required>
            <input
              type="text"
              formControlName="name"
              class="input w-full"
              placeholder="입력해주세요" />
          </app-fieldset>

          <app-fieldset label="연락처" required>
            <input
              type="text"
              formControlName="contact"
              appFormatInput="phone"
              placeholder="010-1234-5678"
              maxlength="13"
              class="input w-full" />
          </app-fieldset>
        </div>
      </div>
    </form>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class RegistrationInfoComponent {
  form = input.required<FormGroup>();
  events = input<EventDto[]>([]);
}
